import { BookmarkModel } from './bookmark.model';

export abstract class SortModel<T> {
    label: string;
    fields: (keyof T)[];
    ascending: boolean;
}

export class BookmarkSortModel extends SortModel<BookmarkModel> {
}

export function getModelValue<T>(model: T, fieldNames: (keyof T)[]): T[keyof T] {
    return fieldNames
        .map((field) => model[field])
        // account for valid falsy '', 0, false, null
        .find((value) => typeof (value) !== 'undefined');
}

export function sortModels<T>(models: T[], fieldNames: (keyof T)[], ascending: boolean): T[] {
    const collator = new Intl.Collator('en-US', { sensitivity: 'base' });

    return models.sort((a, b) => {
        const aValue = getModelValue<T>(a, fieldNames) || '';
        const bValue = getModelValue<T>(b, fieldNames) || '';

        return ((ascending) ? 1 : -1) * collator.compare(aValue.toString(), bValue.toString());
    });
}
